import {Component} from '@angular/core';
import {FooterComponent} from "../footer/footer.component";
import {NavbarComponent} from "../navbar/navbar.component";
import {RouterLink, RouterOutlet} from "@angular/router";
import {ScrollToTopComponent} from "../../components/scroll-to-top/scroll-to-top.component";
import {SwitcherComponent} from "../../components/switcher/switcher.component";
import {AuthenticationService} from '../../core/services/authentication/authentication.service';
import {UserInfo} from '../../core/models/user/user-info.model';

@Component({
  selector: 'app-user-layout',
  standalone: true,
  imports: [
    FooterComponent,
    NavbarComponent,
    RouterOutlet,
    ScrollToTopComponent,
    SwitcherComponent,
    RouterLink
  ],
  templateUrl: './user-layout.component.html',
  styleUrl: './user-layout.component.scss'
})
export class UserLayoutComponent {

  constructor(
    private readonly authService: AuthenticationService
  ) {
  }

  get user(): UserInfo | undefined {
    return this.authService.userData;
  }

}
